import { useState, useEffect } from 'react'
import MapaBrasil from '../../atoms/MapaBrasil'
import imgIfood from '../../../assets/ifood.webp'
import imgSaipos from '../../../assets/Saipos_logo.png'
import imgAnotaAi from '../../../assets/Anota-AI.png'
import imgNemo from '../../../assets/nemo.webp'
import imgDeliveryDireto from '../../../assets/deliveryDireto.webp'
import imgMenew from '../../../assets/menew.webp'
import Zoom from 'react-reveal/Zoom'
import * as Styled from './style'
import VantagensEmpresa from '../../molecules/VantagensEmpresa'
import EntreEmContato from '../EntreEmContato'
import ProcessoDeEntrega from '../ProcessoDeEntrega'
import { getLocalidadeAtendidas } from '../../../services/api'

export default function VantagensParaEmpresa() {
  const [localidades, setLocalidades] = useState([])
  const [estadoHover, setEstadoHover] = useState(null)

  useEffect(() => {
    getLocalidadeAtendidas()
      .then(setLocalidades)
      .catch(() => {})
  }, [])

  const localidadesPorEstado = localidades.reduce((acc, l) => {
    if (!acc[l.estado]) acc[l.estado] = []
    acc[l.estado].push(l.cidade)
    return acc
  }, {})

  function openWhatsAppCidade() {
    const mensagem = 'Olá, gostaria de saber quando a Moovery chegará na minha cidade!'
    const params = new URLSearchParams({ text: mensagem })
    window.open(`https://wa.me/5508005900335?${params}`)
  }

  return (
    <>
      <Styled.Container>
        <Zoom>
          <Styled.ElementVantagens>
            <div className="descricaoGroup">
              <Styled.TitleGroupLeft>
                <Styled.Title>Junte-se a nós</Styled.Title>
                <Styled.SubTitle>Conheça nossas vantagens</Styled.SubTitle>
              </Styled.TitleGroupLeft>
              <p style={{ textAlign: 'left' }}>
                Entregamos nosso serviço de pessoas para pessoas <br /> com ética, responsabilidade,
                transparência, empatia, liderança e inovação.
              </p>
            </div>
            <VantagensEmpresa />
          </Styled.ElementVantagens>
        </Zoom>
        <Styled.BackgroundPurple>
          <Zoom>
            <Styled.ElementVantagensWhite>
              <div className="imgsGroup">
                <div className="imgLine">
                  <img src={imgDeliveryDireto} alt="" />
                  <img src={imgNemo} alt="" />
                  <img src={imgMenew} alt="" />
                </div>
                <div className="imgLine">
                  <img src={imgIfood} alt="" />
                  <img
                    style={{ backgroundColor: 'white', padding: '.3rem' }}
                    src={imgSaipos}
                    alt=""
                    width={125}
                    height={125}
                  />
                  <img style={{ backgroundColor: 'white' }} src={imgAnotaAi} alt="" />
                </div>
              </div>
              <div className="descricaoGroup">
                <div className="titleGroup">
                  <Styled.Title>Integrações</Styled.Title>
                  <Styled.SubTitle>Conheça nossas integrações!</Styled.SubTitle>
                </div>
                <p style={{ textAlign: 'right' }}>
                  Integramos com as principais plataformas de vendas e PDV do <br /> Brasil! Ifood,
                  Anota.ai, Delivery Direto, Nemo, Saipos, Menew
                </p>
              </div>
            </Styled.ElementVantagensWhite>
          </Zoom>
        </Styled.BackgroundPurple>
        <ProcessoDeEntrega />

        <Zoom>
          <Styled.ModalidadesSection>
            <Styled.TitleGroupLeft style={{ alignItems: 'center', textAlign: 'center' }}>
              <Styled.Title>Modalidades</Styled.Title>
              <Styled.SubTitle>Escolha o modelo ideal para o seu negócio</Styled.SubTitle>
            </Styled.TitleGroupLeft>
            <Styled.ModalidadesCards>
              <Styled.ModalidadeCard $destaque>
                <span></span>
                <h3>Moovery + Própria</h3>
                <p className="descricao">
                  Use nossa frota de entregadores na sua região, e gerencie a sua própria logística
                </p>
                <ul className="features">
                  <li>Frota Moovery na sua região</li>
                  <li>Gestão da sua própria frota</li>
                  <li>Roteirização e despacho</li>
                  <li>Integrações com marketplaces</li>
                </ul>
              </Styled.ModalidadeCard>
              <Styled.ModalidadeCard>
                <span className="badge">100% do Brasil</span>
                <h3>Logística Própria</h3>
                <p className="descricao">
                  Gerencie sua frota, roteirização, despacho e integrações com marketplaces usando
                  nossa plataforma, sem usar nossos entregadores
                </p>
                <ul className="features">
                  <li>Gestão completa da sua frota</li>
                  <li>Roteirização inteligente</li>
                  <li>Despacho automatizado</li>
                  <li>Integrações com marketplaces</li>
                  <li>Disponível em todo o Brasil</li>
                </ul>
              </Styled.ModalidadeCard>
            </Styled.ModalidadesCards>
          </Styled.ModalidadesSection>
        </Zoom>

        <Styled.BackgroundPurple>
          <Zoom>
            <Styled.ElementVantagens>
              <div className="descricaoGroup">
                <Styled.TitleGroupLeft>
                  <Styled.Title>Localidades atendidas</Styled.Title>
                  <Styled.LocalidadesBadge>
                    <span className="dot" />
                    Cobertura Logística Moovery
                  </Styled.LocalidadesBadge>
                  <Styled.LocalidadesList>
                    {localidades.length > 0 ? (
                      Object.entries(localidadesPorEstado)
                        .sort(([a], [b]) => a.localeCompare(b))
                        .map(([estado, cidades]) => (
                          <div
                            key={estado}
                            className={`estado-row ${estadoHover === estado ? 'ativo' : ''}`}
                            onMouseEnter={() => setEstadoHover(estado)}
                            onMouseLeave={() => setEstadoHover(null)}
                          >
                            <strong>{estado}</strong>
                            <span>{cidades.join(', ')}</span>
                          </div>
                        ))
                    ) : (
                      <span>Carregando...</span>
                    )}
                  </Styled.LocalidadesList>
                </Styled.TitleGroupLeft>
                <p style={{ textAlign: 'left' }}>
                  Estamos trabalhando para expandir cada vez mais as localidades atendidas.
                </p>
                <Styled.BannerBrasil>
                  <span className="icon-brasil" role="img" aria-label="Brasil">
                    🇧🇷
                  </span>
                  <div className="texto">
                    <strong>Logística Própria disponível em todo o Brasil</strong>
                    <span>Gerencie sua frota de qualquer lugar do país</span>
                  </div>
                </Styled.BannerBrasil>
                <Styled.CtaExpansao onClick={openWhatsAppCidade}>
                  Não encontrou sua cidade? Avise-nos!
                </Styled.CtaExpansao>
              </div>
              <MapaBrasil estadoHover={estadoHover} onEstadoHover={setEstadoHover} />
            </Styled.ElementVantagens>
          </Zoom>
        </Styled.BackgroundPurple>
        <Zoom>
          <EntreEmContato />
        </Zoom>
      </Styled.Container>
    </>
  )
}
